// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Public auth pages — match Our Memories marketing landing */

.om-auth-page {
  --om-auth-display: "Cormorant Garamond", Georgia, "Times New Roman", serif;
  --om-auth-body: "Outfit", "Segoe UI", sans-serif;
  font-family: var(--om-auth-body);
}

.om-auth-page h1,
.om-auth-page h2,
.om-auth-page .om-auth-display {
  font-family: var(--om-auth-display);
}

.om-public-grain {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0.025;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

html.dark .om-public-grain {
  opacity: 0.035;
}

/* Soft stone wash — no purple orbs */
.om-public-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(110px);
  pointer-events: none;
}

.om-public-orb-violet {
  width: 28rem;
  height: 28rem;
  top: -12rem;
  right: -10rem;
  background: radial-gradient(circle, rgba(31, 58, 52, 0.1), transparent 70%);
}

.om-public-orb-fuchsia {
  width: 22rem;
  height: 22rem;
  top: 45%;
  left: -10rem;
  background: radial-gradient(circle, rgba(15, 23, 42, 0.06), transparent 70%);
}

.om-public-orb-indigo {
  width: 18rem;
  height: 18rem;
  bottom: -4rem;
  right: 20%;
  background: radial-gradient(circle, rgba(232, 228, 220, 0.7), transparent 70%);
}

html.dark .om-public-orb-violet {
  background: radial-gradient(circle, rgba(31, 58, 52, 0.22), transparent 70%);
}

html.dark .om-public-orb-fuchsia {
  background: radial-gradient(circle, rgba(255, 252, 248, 0.04), transparent 70%);
}

html.dark .om-public-orb-indigo {
  background: radial-gradient(circle, rgba(255, 252, 248, 0.03), transparent 70%);
}

.om-auth-visual {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  aspect-ratio: 16 / 10;
  background: #0f172a;
}

.om-auth-visual > img,
.om-auth-visual__media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 28%;
  display: block;
}

.om-auth-visual__veil {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    linear-gradient(180deg, rgba(10, 9, 8, 0.12) 0%, rgba(10, 9, 8, 0.62) 100%),
    linear-gradient(90deg, rgba(10, 9, 8, 0.4) 0%, transparent 55%);
}

.om-auth-visual__caption {
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 14px;
  border: 1px solid rgba(255, 252, 248, 0.16);
  background: rgba(10, 9, 8, 0.55);
  backdrop-filter: blur(12px);
  color: #ffffff;
}

.om-auth-visual__caption img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: contain;
}

.om-auth-visual__caption strong {
  display: block;
  font-family: var(--om-auth-display);
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

.om-auth-visual__caption span {
  display: block;
  margin-top: 0.1rem;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(255, 252, 248, 0.78);
}

.om-auth-collage {
  display: grid;
  grid-template-columns: 1.35fr 0.9fr;
  grid-template-rows: 1fr 1fr;
  gap: 0.55rem;
  border-radius: 18px;
  overflow: hidden;
  min-height: 280px;
  aspect-ratio: 16 / 11;
  background: transparent;
}

.om-auth-collage__main {
  grid-row: 1 / -1;
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  background: #0f172a;
}

.om-auth-collage__side {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  background: #0f172a;
}

.om-auth-collage__main img,
.om-auth-collage__side img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.om-auth-collage__main img {
  object-position: center 40%;
}

.om-auth-story {
  margin-top: 1.1rem;
  max-width: 36rem;
}

.om-auth-story__title {
  margin: 0;
  font-family: var(--om-auth-display);
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
}

html.dark .om-auth-story__title {
  color: #ffffff;
}

.om-auth-story__text {
  margin: 0.45rem 0 0;
  font-size: 0.88rem;
  line-height: 1.6;
  color: #64748b;
}

html.dark .om-auth-story__text {
  color: #a8a399;
}

.om-login-form {
  display: grid;
  gap: 1.1rem;
}

.om-login-form--otp {
  margin-top: 0.15rem;
}

.om-login-field {
  display: grid;
  gap: 0.45rem;
}

.om-login-field__control {
  position: relative;
}

.om-login-field__icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  width: 14px;
  height: 14px;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
}

.om-login-field__toggle {
  position: absolute;
  right: 0.65rem;
  top: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  transform: translateY(-50%);
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}

.om-login-field__toggle:hover {
  color: #0f172a;
  background: rgba(15, 23, 42, 0.05);
}

html.dark .om-login-field__toggle:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.om-login-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.875rem;
}

.om-login-remember {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.om-login-remember__box {
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  accent-color: #0f172a;
}

.om-login-divider {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin: 1.5rem 0 1.15rem;
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.om-login-divider::before,
.om-login-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: rgba(15, 23, 42, 0.1);
}

html.dark .om-login-divider::before,
html.dark .om-login-divider::after {
  background: rgba(255, 255, 255, 0.1);
}

.om-login-otp-code {
  letter-spacing: 0.28em;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 600;
}

.om-login-change {
  margin-top: 0.15rem;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  cursor: pointer;
}

.om-login-change:hover {
  color: #0f172a;
}

html.dark .om-login-change {
  color: #a8a399;
}

html.dark .om-login-change:hover {
  color: #ffffff;
}

/* Alternate sign-in actions — full buttons, not a switch/tab bar */
.om-login-actions {
  display: grid;
  gap: 0.65rem;
  margin-top: 1rem;
}

.om-login-actions__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  width: 100%;
  min-height: 48px;
  padding: 0 1.1rem;
  border: 1px solid rgba(15, 23, 42, 0.14);
  border-radius: 999px;
  background: #ffffff;
  color: #0f172a;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
}

.om-login-actions__btn:hover {
  background: #f1f5f9;
  border-color: rgba(15, 23, 42, 0.22);
}

.om-login-actions__btn:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

html.dark .om-login-actions__btn {
  background: #1c1a18;
  border-color: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

html.dark .om-login-actions__btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.om-login-actions__icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: #64748b;
}

html.dark .om-login-actions__icon {
  color: #a8a399;
}

/* Login / register autofill */
.om-auth-input:-webkit-autofill,
.om-auth-input:-webkit-autofill:hover,
.om-auth-input:-webkit-autofill:focus,
.om-auth-input:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #0f172a !important;
  color: #0f172a !important;
  caret-color: #0f172a !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: rgba(15, 23, 42, 0.14) !important;
  -webkit-transition: background-color 99999s ease-in-out 0s;
  transition: background-color 99999s ease-in-out 0s;
}

html.dark .om-auth-input:-webkit-autofill,
html.dark .om-auth-input:-webkit-autofill:hover,
html.dark .om-auth-input:-webkit-autofill:focus,
html.dark .om-auth-input:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px #121214 inset !important;
  -webkit-text-fill-color: #ffffff !important;
  color: #ffffff !important;
  caret-color: #ffffff !important;
  background-color: #121214 !important;
  background-image: none !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
}

@media (prefers-reduced-motion: reduce) {
  .om-public-orb {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/auth/PublicMemoriesShell.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,0EAA0E;EAC1E,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,yDAAqT;AACvT;;AAEA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,2EAA2E;AAC7E;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,UAAU;EACV,8EAA8E;AAChF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;;mEAEiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;;;;EAKE,iDAAiD;EACjD,2CAA2C;EAC3C,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;EACjC,+CAA+C;EAC/C,0DAAkD;EAAlD,kDAAkD;AACpD;;AAEA;;;;EAKE,iDAAiD;EACjD,2CAA2C;EAC3C,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Public auth pages — match Our Memories marketing landing */\n\n.om-auth-page {\n  --om-auth-display: \"Cormorant Garamond\", Georgia, \"Times New Roman\", serif;\n  --om-auth-body: \"Outfit\", \"Segoe UI\", sans-serif;\n  font-family: var(--om-auth-body);\n}\n\n.om-auth-page h1,\n.om-auth-page h2,\n.om-auth-page .om-auth-display {\n  font-family: var(--om-auth-display);\n}\n\n.om-public-grain {\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  opacity: 0.025;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n}\n\nhtml.dark .om-public-grain {\n  opacity: 0.035;\n}\n\n/* Soft stone wash — no purple orbs */\n.om-public-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(110px);\n  pointer-events: none;\n}\n\n.om-public-orb-violet {\n  width: 28rem;\n  height: 28rem;\n  top: -12rem;\n  right: -10rem;\n  background: radial-gradient(circle, rgba(31, 58, 52, 0.1), transparent 70%);\n}\n\n.om-public-orb-fuchsia {\n  width: 22rem;\n  height: 22rem;\n  top: 45%;\n  left: -10rem;\n  background: radial-gradient(circle, rgba(15, 23, 42, 0.06), transparent 70%);\n}\n\n.om-public-orb-indigo {\n  width: 18rem;\n  height: 18rem;\n  bottom: -4rem;\n  right: 20%;\n  background: radial-gradient(circle, rgba(232, 228, 220, 0.7), transparent 70%);\n}\n\nhtml.dark .om-public-orb-violet {\n  background: radial-gradient(circle, rgba(31, 58, 52, 0.22), transparent 70%);\n}\n\nhtml.dark .om-public-orb-fuchsia {\n  background: radial-gradient(circle, rgba(255, 252, 248, 0.04), transparent 70%);\n}\n\nhtml.dark .om-public-orb-indigo {\n  background: radial-gradient(circle, rgba(255, 252, 248, 0.03), transparent 70%);\n}\n\n.om-auth-visual {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  aspect-ratio: 16 / 10;\n  background: #0f172a;\n}\n\n.om-auth-visual > img,\n.om-auth-visual__media {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 28%;\n  display: block;\n}\n\n.om-auth-visual__veil {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  background:\n    linear-gradient(180deg, rgba(10, 9, 8, 0.12) 0%, rgba(10, 9, 8, 0.62) 100%),\n    linear-gradient(90deg, rgba(10, 9, 8, 0.4) 0%, transparent 55%);\n}\n\n.om-auth-visual__caption {\n  position: absolute;\n  left: 1rem;\n  right: 1rem;\n  bottom: 1rem;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 252, 248, 0.16);\n  background: rgba(10, 9, 8, 0.55);\n  backdrop-filter: blur(12px);\n  color: #ffffff;\n}\n\n.om-auth-visual__caption img {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  object-fit: contain;\n}\n\n.om-auth-visual__caption strong {\n  display: block;\n  font-family: var(--om-auth-display);\n  font-size: 1.05rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\n.om-auth-visual__caption span {\n  display: block;\n  margin-top: 0.1rem;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba(255, 252, 248, 0.78);\n}\n\n.om-auth-collage {\n  display: grid;\n  grid-template-columns: 1.35fr 0.9fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 0.55rem;\n  border-radius: 18px;\n  overflow: hidden;\n  min-height: 280px;\n  aspect-ratio: 16 / 11;\n  background: transparent;\n}\n\n.om-auth-collage__main {\n  grid-row: 1 / -1;\n  position: relative;\n  overflow: hidden;\n  border-radius: 14px;\n  background: #0f172a;\n}\n\n.om-auth-collage__side {\n  position: relative;\n  overflow: hidden;\n  border-radius: 14px;\n  background: #0f172a;\n}\n\n.om-auth-collage__main img,\n.om-auth-collage__side img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.om-auth-collage__main img {\n  object-position: center 40%;\n}\n\n.om-auth-story {\n  margin-top: 1.1rem;\n  max-width: 36rem;\n}\n\n.om-auth-story__title {\n  margin: 0;\n  font-family: var(--om-auth-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\nhtml.dark .om-auth-story__title {\n  color: #ffffff;\n}\n\n.om-auth-story__text {\n  margin: 0.45rem 0 0;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  color: #64748b;\n}\n\nhtml.dark .om-auth-story__text {\n  color: #a8a399;\n}\n\n.om-login-form {\n  display: grid;\n  gap: 1.1rem;\n}\n\n.om-login-form--otp {\n  margin-top: 0.15rem;\n}\n\n.om-login-field {\n  display: grid;\n  gap: 0.45rem;\n}\n\n.om-login-field__control {\n  position: relative;\n}\n\n.om-login-field__icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  width: 14px;\n  height: 14px;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.om-login-field__toggle {\n  position: absolute;\n  right: 0.65rem;\n  top: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  transform: translateY(-50%);\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n}\n\n.om-login-field__toggle:hover {\n  color: #0f172a;\n  background: rgba(15, 23, 42, 0.05);\n}\n\nhtml.dark .om-login-field__toggle:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.om-login-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n}\n\n.om-login-remember {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.om-login-remember__box {\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.25rem;\n  accent-color: #0f172a;\n}\n\n.om-login-divider {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin: 1.5rem 0 1.15rem;\n  color: #94a3b8;\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.om-login-divider::before,\n.om-login-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: rgba(15, 23, 42, 0.1);\n}\n\nhtml.dark .om-login-divider::before,\nhtml.dark .om-login-divider::after {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.om-login-otp-code {\n  letter-spacing: 0.28em;\n  text-align: center;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n.om-login-change {\n  margin-top: 0.15rem;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.om-login-change:hover {\n  color: #0f172a;\n}\n\nhtml.dark .om-login-change {\n  color: #a8a399;\n}\n\nhtml.dark .om-login-change:hover {\n  color: #ffffff;\n}\n\n/* Alternate sign-in actions — full buttons, not a switch/tab bar */\n.om-login-actions {\n  display: grid;\n  gap: 0.65rem;\n  margin-top: 1rem;\n}\n\n.om-login-actions__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  width: 100%;\n  min-height: 48px;\n  padding: 0 1.1rem;\n  border: 1px solid rgba(15, 23, 42, 0.14);\n  border-radius: 999px;\n  background: #ffffff;\n  color: #0f172a;\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;\n}\n\n.om-login-actions__btn:hover {\n  background: #f1f5f9;\n  border-color: rgba(15, 23, 42, 0.22);\n}\n\n.om-login-actions__btn:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\nhtml.dark .om-login-actions__btn {\n  background: #1c1a18;\n  border-color: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n}\n\nhtml.dark .om-login-actions__btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.om-login-actions__icon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  color: #64748b;\n}\n\nhtml.dark .om-login-actions__icon {\n  color: #a8a399;\n}\n\n/* Login / register autofill */\n.om-auth-input:-webkit-autofill,\n.om-auth-input:-webkit-autofill:hover,\n.om-auth-input:-webkit-autofill:focus,\n.om-auth-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;\n  box-shadow: 0 0 0 1000px #ffffff inset !important;\n  -webkit-text-fill-color: #0f172a !important;\n  color: #0f172a !important;\n  caret-color: #0f172a !important;\n  background-color: #ffffff !important;\n  background-image: none !important;\n  border-color: rgba(15, 23, 42, 0.14) !important;\n  transition: background-color 99999s ease-in-out 0s;\n}\n\nhtml.dark .om-auth-input:-webkit-autofill,\nhtml.dark .om-auth-input:-webkit-autofill:hover,\nhtml.dark .om-auth-input:-webkit-autofill:focus,\nhtml.dark .om-auth-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #121214 inset !important;\n  box-shadow: 0 0 0 1000px #121214 inset !important;\n  -webkit-text-fill-color: #ffffff !important;\n  color: #ffffff !important;\n  caret-color: #ffffff !important;\n  background-color: #121214 !important;\n  background-image: none !important;\n  border-color: rgba(255, 255, 255, 0.12) !important;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .om-public-orb {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
